import * as tslib_1 from "tslib";
import React, { forwardRef } from 'react';
import { default as GridRow } from './GridRow';
import { getGridConfiguration } from './helpers';
import Waypoint from 'react-waypoint';
var Grid = forwardRef(function (_a, ref) {
    var bounds = _a.bounds, breakpoints = _a.breakpoints, className = _a.className, containerWidth = _a.containerWidth, screenWidth = _a.screenWidth, contentStrip = _a.contentStrip, contentStripHeight = _a.contentStripHeight, contentStripIndex = _a.contentStripIndex, elementCount = _a.elementCount, _b = _a.enableScrollOptim, enableScrollOptim = _b === void 0 ? false : _b, spacing = _a.spacing, onOffsetReached = _a.onOffsetReached, props = tslib_1.__rest(_a, ["bounds", "breakpoints", "className", "containerWidth", "screenWidth", "contentStrip", "contentStripHeight", "contentStripIndex", "elementCount", "enableScrollOptim", "spacing", "onOffsetReached"]);
    var hasContentStrip = contentStrip !== undefined &&
        contentStripHeight !== undefined &&
        contentStripIndex !== undefined;
    var _c = getGridConfiguration({
        breakpoints: breakpoints,
        containerWidth: containerWidth,
        screenWidth: screenWidth,
        elementSpacing: spacing,
    }), elementWidth = _c.elementWidth, elementHeight = _c.elementHeight, elementSpacing = _c.elementSpacing, elementsPerRow = _c.elementsPerRow;
    var rows = [];
    var rowCount = Math.ceil(elementCount / elementsPerRow);
    for (var i = 0; i < rowCount; i++) {
        var itemIndex = i * elementsPerRow;
        if (hasContentStrip && contentStripIndex === i) {
            rows.push(contentStrip);
            if (bounds) {
                // Everything past the strip needs its offsetTop adjusted downwards
                // we apply this once from the row after the strip
                bounds.offsetTop += contentStripHeight;
            }
        }
        rows.push(React.createElement(OffsetWrap, { key: "grid-row" + i, start: itemIndex, onOffsetReached: onOffsetReached },
            React.createElement(GridRow, tslib_1.__assign({ rowNumber: i, start: itemIndex, end: Math.min(itemIndex + elementsPerRow, elementCount), key: "grid-row" + i, bounds: bounds, elementWidth: elementWidth, elementHeight: elementHeight, elementSpacing: elementSpacing }, props))));
    }
    return (React.createElement("div", { className: className, ref: ref }, rows));
});
Grid.displayName = 'Grid';
var OffsetWrap = function (_a) {
    var onOffsetReached = _a.onOffsetReached, start = _a.start, children = _a.children;
    if (onOffsetReached) {
        var cb = function () {
            onOffsetReached(start);
        };
        return (React.createElement(Waypoint, { fireOnRapidScroll: false, bottomOffset: '90%', key: "offset-" + start, onEnter: cb },
            React.createElement("div", null, children)));
    }
    return React.createElement(React.Fragment, null, children);
};
OffsetWrap.displayName = 'GridRowOffsetTracker';
export default Grid;
//# sourceMappingURL=Grid.js.map